import axios from 'axios';
import { api as baseURL } from '@/config/index.js';
import router from '@/router/index.js';
import app from '@/main';
import { setUser, setToken, loggedIn, logout } from '@/plugins/auth';
export const api = axios.create({
	baseURL,
});

// for every request start the progress
api.interceptors.request.use(config => {
	app.$Progress.start();
	return config;
});

// finish when a response is received
api.interceptors.response.use(response => {
	app.$Progress.hide();
	return response;
});

/** @type {Array} */
let queueRequest = [];

/** @type {boolean} */
let isRefreshRequesting = false;

api.interceptors.response.use(null, err => {
	const { response, config } = err;

	if (response.status === 401) {
		// Si no hemos iniciado sesión antes intentar obtener un nuevo token
		if (!loggedIn()) {
			return Promise.reject(err);
		}

		// Si esta autenticado, Probablemente el token expiro se intenta renorvarlo
		// Y envía todas las solicitudes fallidas nuevamente
		if (!isRefreshRequesting) {
			isRefreshRequesting = true;

			const vuex = JSON.parse(localStorage.getItem('vuex'));

			// Enviamos peticion para refrescar el token
			api.get('/refresh-token', {
				headers: { refresh: vuex.User.refreshToken },
			})
				.then(({ data }) => {
					// Nuevo token recivido
					setToken(data.token);
					setUser(data.user);
					queueRequest.forEach(cb => cb(data.token));
				})
				.catch(() => {
					// cerramos sesion
					// redirigimos a la página de inicio de sesión
					logout();
					api.defaults.headers['Authorization'] = null;
					queueRequest.forEach(cb => cb(null));
					router.replace({ name: 'auth' });
				})
				.finally(() => {
					// Limpiar la cola de solicitudes fallidas
					queueRequest = [];
					isRefreshRequesting = false;
				});
		}

		return new Promise((resolve, reject) => {
			// Ejecutamos todas las solicitudes pendientes en la cola
			queueRequest.push(token => {
				if (token) {
					config.headers.Authorization = 'Bearer ' + token;
					resolve(api(config));
				}
				reject(err);
			});
		});
	}

	return Promise.reject(err);
});

/**
 * Performs api calls sending the required authentication headers
 * @param {String} url
 * @param {Object} options
 */
const fetch = async (url, options) => {
	const headers = {};
	const vuex = JSON.parse(localStorage.getItem('vuex'));
	const loggedIn = vuex && vuex.User.token && vuex.User.profile;
	// Setting Authorization header
	// authorization: xxxxxxx.xxxxxxxx.xxxxxx
	if (loggedIn) {
		headers['Authorization'] = `Bearer ${vuex.User.token}`;
	}

	const response = await api(url, {
		headers,
		...options,
	});
	const res = await _checkStatus(response);
	return res;
};

/**
 * checkstatus of the api response
 * @param {Object} response
 * @return {Object} response || error
 * @private
 */
const _checkStatus = response => {
	// raises an error in case response status is not a success
	if (response.status >= 200 && response.status < 300) {
		// Success status lies between 200 to 300
		return response;
	} else {
		throw response;
	}
};

export default fetch;
